import { render, staticRenderFns } from "./ticketHeaderCard.vue?vue&type=template&id=620565a7&scoped=true&"
import script from "./ticketHeaderCard.vue?vue&type=script&lang=js&"
export * from "./ticketHeaderCard.vue?vue&type=script&lang=js&"
import style0 from "./ticketHeaderCard.vue?vue&type=style&index=0&id=620565a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620565a7",
  null
  
)

export default component.exports